import React, { useState } from 'react';
import {
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon
} from '@mui/material';
import {
  ReceiptLong as InvoiceIcon,
  ShoppingCart as PurchaseIcon,
  Payments as ExpenseIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface GlobalActionButtonProps {
  position?: {
    bottom?: number;
    right?: number;
    top?: number;
    left?: number;
  };
}

const GlobalActionButton: React.FC<GlobalActionButtonProps> = ({
  position = { bottom: 24, right: 24 }
}) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleCreateInvoice = () => {
    navigate('/invoices/new');
    setOpen(false);
  };

  const handleCreatePurchase = () => {
    navigate('/purchases', { state: { openNewPurchase: true } });
    setOpen(false);
  };

  const handleCreateExpense = () => {
    navigate('/expenses', { state: { openNewExpense: true } });
    setOpen(false);
  };

  const fabActions = [
    { icon: <InvoiceIcon />, name: 'Create Invoice', action: handleCreateInvoice },
    { icon: <PurchaseIcon />, name: 'Record Purchase', action: handleCreatePurchase },
    { icon: <ExpenseIcon />, name: 'Record Expense', action: handleCreateExpense },
  ];

  return (
    <SpeedDial
      ariaLabel="Create new entry"
      sx={{
        position: 'fixed',
        ...position,
        zIndex: 1050, // Higher than most UI elements
      }}
      icon={<SpeedDialIcon />}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      FabProps={{
        sx: {
          backgroundImage: 'var(--primary-gradient)',
          '&:hover': {
            backgroundImage: 'var(--primary-gradient)',
            opacity: 0.9,
          },
        },
      }}
    >
      {fabActions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={action.action}
          sx={{
            '& .MuiSpeedDialAction-staticTooltipLabel': {
              minWidth: 120,
              textAlign: 'center',
            },
          }}
        />
      ))}
    </SpeedDial>
  );
};

export default GlobalActionButton; 